import { render, staticRenderFns } from "./EditOutlinedIcon.vue?vue&type=template&id=56865a2f&scoped=true"
import script from "./EditOutlinedIcon.vue?vue&type=script&lang=js"
export * from "./EditOutlinedIcon.vue?vue&type=script&lang=js"
import style0 from "./EditOutlinedIcon.vue?vue&type=style&index=0&id=56865a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56865a2f",
  null
  
)

export default component.exports